var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @file Modal
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useUncontrolledShow } from '@tencent/glue-react-use';
import { useStyleTransform } from '../hooks/useStyleTransform';
export function Modal(props) {
    var id = props.id, _a = props.style, elemStyle = _a === void 0 ? {} : _a, _b = props.className, elemClassName = _b === void 0 ? '' : _b, children = props.children, _c = props.mask, mask = _c === void 0 ? true : _c, _d = props.maskClosable, maskClosable = _d === void 0 ? true : _d, _e = props.maskColor, maskColor = _e === void 0 ? 'transparent' : _e, _f = props.position, position = _f === void 0 ? 'center' : _f, _g = props.animationType, animationType = _g === void 0 ? 'slide' : _g, show = props.show, defaultShow = props.defaultShow, onShow = props.onShow, onHide = props.onHide, onVisibleChange = props.onVisibleChange;
    var _h = useState(), modelContainer = _h[0], setModelContainer = _h[1];
    var config = useStyleTransform(elemStyle, 'xj-h5-modal-inner', elemClassName);
    var _j = useUncontrolledShow({
        show: show,
        defaultShow: defaultShow,
        onShow: onShow,
        onHide: onHide,
        onVisibleChange: onVisibleChange,
    }), visible = _j[0], setVisible = _j[1];
    var onHippyDismiss = useCallback(function (e) {
        e.stopPropagation();
        setVisible(false);
    }, []);
    useEffect(function () {
        // 规避ssr渲染
        var div = document.createElement('div');
        document.body.appendChild(div);
        setModelContainer(div);
    }, []);
    if (!modelContainer) {
        return null;
    }
    return createPortal(React.createElement("div", { id: id, className: "xj-h5-modal xj-h5-modal-".concat(position, " ").concat(visible ? "xj-h5-modal-".concat(animationType) : ''), style: {
            display: visible ? 'flex' : 'none',
        } },
        mask && (React.createElement("div", { className: "xj-h5-modal-mask", style: { backgroundColor: maskColor }, onClick: maskClosable ? onHippyDismiss : undefined })),
        React.createElement("div", __assign({}, config), children)), modelContainer);
}
